import React from 'react';
import ReactDOM from 'react-dom';

import { API } from './resources/api';
import global from './stores/GlobalStore';
import config from './configs/appConfig';

import App from './components/Home/App';
import UserStore from './stores/UserStore';
import AudioStore from './stores/AudioStore';
import PodcastStore from './stores/PodcastStore';

import './styles/variables.scss';
import './styles/index.scss';
import './styles/fontawesome-all.min.css';

function start() {
  initGlobalContext();

  return ReactDOM.render(<App />, document.getElementById('root'));
}

function initGlobalContext() {
  global().setApi(new API({}, { service_url: config.server.endpoint }));
  global().setUserStore(new UserStore());
  global().setAudioStore(new AudioStore());
  global().setPodcastStore(new PodcastStore());
}

start();
